import { AuthInfo } from '@arpeggi/shared'
import axios from '../../lib/axios'

export const useAuthAPI = () => {
  const getAuthInfo = async (walletAddress: string) => {
    const { data } = await axios.get<AuthInfo>(`/api/v2/auth/${walletAddress}/info`)

    return data
  }

  return { getAuthInfo }
}
